import * as React from "react";
import { Spin } from "antd";
import CheckboxGroup from "../../components/app/CheckboxGroup";
import Text from "antd/lib/typography/Text";
import { IEvaluationTypesPresentationModel } from "../../../presenter/formconfiguration/FormTypesPresenter";

export interface State {}

export interface Props {
  translate: any;
  assignedEvaluationTypeIds?: number[];
  evaluationTypes?: IEvaluationTypesPresentationModel[];
  onEvaluationTypeSelectChange?: any;
  evaluationTypeLoader?: boolean;
}

export default class FormTypesExpanded extends React.Component<Props, State> {
  render() {
    const {
      translate,
      assignedEvaluationTypeIds,
      evaluationTypes,
      evaluationTypeLoader,
      onEvaluationTypeSelectChange
    } = this.props;

    return (
      <div>
        <Spin spinning={evaluationTypeLoader}>
        <h3>{translate("reports_page.form_types_datagrid.expanded.title")}</h3>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {evaluationTypes && evaluationTypes.length ? (
              <CheckboxGroup
                options={evaluationTypes}
                onChange={e => {
                  onEvaluationTypeSelectChange(e);
                }}
                value={assignedEvaluationTypeIds}
                columnCount={3}
              />
            ) : (
              <Text>{translate("data_grid.empty_text")}</Text>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
